<template>
  <div>
    <section class="section is-main-section">
      <card-component title="Permission Form" icon="shield-check" has-back>
        <form @submit.prevent="submit">
          <b-field label="All Access" horizontal>
            <b-switch v-model="form.isAllMethod" />
          </b-field>
          <b-field
            v-if="!form.isAllMethod"
            :message="$v.method.msg"
            :type="$v.method.status"
            horizontal
            label="Access type"
          >
            <b-select placeholder="Choose access type" v-model="form.method">
              <option value="GET">Read</option>
              <option value="POST">Insert</option>
              <option value="PUT">Edit</option>
              <option value="DELETE">Delete</option>
            </b-select>
          </b-field>
          <b-field
            :message="$v.module.msg"
            :type="$v.module.status"
            horizontal
            label="Module"
          >
            <b-input placeholder="Module" v-model="form.module" />
          </b-field>
          <b-field
            :message="$v.description.msg"
            :type="$v.description.status"
            horizontal
            label="Description"
          >
            <b-input
              v-model="form.description"
              maxlength="100"
              placeholder="Description"
              type="textarea"
            />
          </b-field>
          <hr />
          <div ref="submit">
            <b-field horizontal>
              <b-button
                type="is-primary"
                :loading="isLoading"
                native-type="submit"
                >Submit</b-button
              >
            </b-field>
          </div>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import { create as createPermission } from '@/api/permission'
import validationMixin from '@/mixins/validation'
import { required, requiredIf, alpha } from '@/utils/validation'
import { shaking } from '@/utils/animation'

export default {
  name: 'CreatePermission',
  mixins: [validationMixin],
  data() {
    return {
      isLoading: false,
      rules: {
        method: [requiredIf(this, 'isAllMethod', false)],
        module: [required],
        description: [required, alpha]
      },
      form: {
        isAllMethod: false,
        method: null,
        module: null,
        description: null
      }
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$valid) {
        this.isLoading = true

        let promise = null

        if (this.form.isAllMethod) {
          const request = [
            createPermission({ ...this.form, method: 'GET' }),
            createPermission({ ...this.form, method: 'POST' }),
            createPermission({ ...this.form, method: 'PUT' }),
            createPermission({ ...this.form, method: 'DELETE' })
          ]

          promise = Promise.all(request)
        } else {
          promise = createPermission(this.form)
        }

        promise
          .then(() => {
            this.$router.back()
          })
          .catch(e => {
            this.$buefy.toast.open({
              message: e.response.data,
              type: 'is-danger',
              queue: false
            })
          })
          .finally(() => { this.isLoading = false })
      } else {
        shaking(this.$refs.submit)
      }
    }
  }
}
</script>
